<template>
    <div class="detail">
        <product-part-one-group :rule_id="rule_id" mode="2" :showCountDown="true" />
        <product-part-three :product_id="product_id" />
        <product-part-four :product_id="product_id" />

        <van-divider>我是底线</van-divider>
        <van-goods-action>
            <van-goods-action-icon icon="shop-o" text="首页" @click="go_home" />
            <van-goods-action-icon icon="chat-o" text="客服" @click="showCS" />
            <van-goods-action-button color="#be99ff" type="warning" :text="button_text_sale" @click="buy_it" />
            <van-goods-action-button color="#7232dd" type="danger" :text="button_text_group" @click="take_group" />
        </van-goods-action>
    </div>
</template>

<script>
    import ProductPartOneGroup from "../../components/Product/ProductPartOneGroup";
    import ProductPartThree from "../../components/Product/ProductPartThree";
    import ProductPartFour from "../../components/Product/ProductPartFour";
    import { mapActions } from 'vuex';
    import store from '@/store';
    import config from '@/config';

    export default {
        name: "ProductDetailGroup",
        components: {ProductPartFour, ProductPartThree, ProductPartOneGroup},
        data(){
            return{
                product_id:this.$route.params.product_id,
                rule_id:this.$route.params.rule_id,         //拼团配置id
                group_id:this.$route.params.group_id,       //拼团记录id，为空时表示当前页是拼团发起页，非空时表示当前页为拼团参与页
                weixin_code:this.$route.query.code,         //query：获取url中get模式参数
                weixin_state:this.$route.query.state,
                openid:this.$store.getters.getLoginUser.openid, //当前购买客户的open_id
                countDownTime: 0,
                rule_info:{},   //拼团模板对象
                button_text_sale:'',
                button_text_group:'',
            }
        },
        methods:{
            ...mapActions([
                'GetSaleToolGroupRuleInfo',
                'GetAppCSInfo',
            ]),
            buy_it(){
                //优惠直购
                let product_id=this.product_id;
                let rule_id=this.rule_id;
                let group_id=this.group_id;
                let price = this.rule_info.sale_price;
                let buy_mode=2;
                let lock_area=this.rule_info.lock_area;
                this.$router.push({name:'CreateOrder',params:{product_id,group_id,price,buy_mode,rule_id,lock_area}});
            },
            take_group(){
                //发起拼团
                let product_id=this.product_id;
                let rule_id=this.rule_id;
                let group_id=this.group_id;
                let price = this.rule_info.group_price;
                let buy_mode=3;
                let lock_area=this.rule_info.lock_area;
                this.$router.push({name:'CreateOrder',params:{product_id,group_id,price,buy_mode,rule_id,lock_area}});
            },
            go_home(){
                this.$router.push({name:'home'});
            },
            loadCSInfo(){
                let mode=2;
                this.GetAppCSInfo({mode}).then(res=>{
                    this.cs=res;
                })
            },
            showCS(){
                this.$imagePreview([this.cs.avatar]);
            },
            loadRuleInfo(){
                let rule_id=this.rule_id;
                this.GetSaleToolGroupRuleInfo({rule_id}).then(res=>{
                    this.rule_info=res;
                    this.button_text_sale='￥'+this.rule_info.sale_price+'优惠直购';
                    if(!this.group_id){
                        this.button_text_group='￥'+this.rule_info.group_price+'发起拼团';
                    }else{
                        this.button_text_group='￥'+this.rule_info.group_price+'参与拼团';
                    }

                })
            }
        },
        mounted() {
            this.loadCSInfo();
            this.loadRuleInfo();
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            // console.log('login user',loginUser);
            if(loginUser&&loginUser.openid){
                next();
            }else{
                //未登录，则发起微信登录授权
                let code = to.query.code;
                let sales_uid=to.params.sales_uid;
                let mode=1; //梅唐四季模式
                // console.log('微信code值',code);
                // console.log('渠道号值',sales_uid);
                if(code){
                    // console.log('----- 开始调用后台微信登录接口 ------');
                    store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                        // console.log('返回对象',res);
                        if(res.status>0){
                            //登录失败
                            next(false);
                        }else{
                            //成功
                            next();
                        }
                    });
                }else{
                    //无code则表示是第一次进入本页，发起微信授权
                    // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev); //debug
                    let redirect_uri = encodeURIComponent(window.location.href);
                    let appid=config.weixin.appid_mt;
                    let state=''; //'product-detail-sale/1004/1002'; //debug
                    let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +appid+
                        '&redirect_uri=' +redirect_uri+
                        '&response_type=code&scope=snsapi_userinfo&' +
                        'state=' +state+
                        '#wechat_redirect';
                    console.log('weixin auth url',auth_url);
                    window.location.href = auth_url;
                }
            }
        },

    }
</script>

<style lang="scss" scoped>
    .detail{
        background-color: #F3F4F5;
    }
    .footer-button{
        margin-left: 5px;
        border-radius: 20px;
    }
</style>
